var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericModalWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_8341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7088 62.5503L48.7485 8.92555C47.0269 5.94374 43.9434 4.16333 40.5 4.16333C37.0567 4.16333 33.973 5.94374 32.2514 8.92555L1.29129 62.5501C-0.43043 65.5323 -0.43043 69.0928 1.29129 72.0747C3.01301 75.0567 6.09639 76.837 9.53983 76.837H71.4601C74.9034 76.837 77.9869 75.0566 79.7088 72.0749C81.4305 69.0928 81.4305 65.5323 79.7088 62.5503ZM75.599 69.7022C74.7351 71.1985 73.1878 72.0917 71.4601 72.0917H9.53983C7.81194 72.0917 6.26471 71.1985 5.40093 69.7022C4.53714 68.2059 4.53714 66.4195 5.40093 64.9232L36.3614 11.2984C37.2252 9.80215 38.7724 8.90894 40.5001 8.90894C42.2277 8.90894 43.7751 9.80215 44.6389 11.2984L75.5992 64.9232C76.4628 66.4195 76.4628 68.2059 75.599 69.7022Z",
    fill: "#EDD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8724 27.8452H38.127V51.5729H42.8724V27.8452Z",
    fill: "#EDD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4997 56.3179C38.7552 56.3179 37.3359 57.7371 37.3359 59.4816C37.3359 61.2261 38.7552 62.6454 40.4997 62.6454C42.2441 62.6454 43.6635 61.2261 43.6635 59.4816C43.6635 57.7371 42.2442 56.3179 40.4997 56.3179Z",
    fill: "#EDD34D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_8341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericModalWarning);
export default __webpack_public_path__ + "static/media/genericModalWarning.e47d07e04c8002f36e3e9b94cccbf33b.svg";
export { ForwardRef as ReactComponent };